const fetchWrapper = {
  baseUrl: '',
  headers: {},

  get: async (url) => {
    return makeRequest(url, { method: 'GET' });
  },
  post: async (url, body) => {
    return makeRequest(url, {
      method: 'POST',
      body: JSON.stringify(body)
    });
  },
  postFile: async (url, formData) => {
    return makeRequest(url, {
      method: 'POST',
      body: formData
    });
  },
  put: async (url, body) => {
    return makeRequest(url, {
      method: 'PUT',
      body: JSON.stringify(body)
    });
  },
  delete: async (url) => {
    return makeRequest(url, { method: 'DELETE' });
  },
  getFileWithPost: async (url, data) => {
    const token = localStorage.getItem('access_token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };

    const response = await fetch(addHost(url), {
      method: 'POST',
      body: JSON.stringify(data),
      headers: headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      const errorData = errorText && JSON.parse(errorText);
      const error = (errorData && errorData.message) || response.statusText;
      throw new Error(error);
    }

    return response.blob();
  },

  getFile: async (url) => {
    const token = localStorage.getItem('access_token');
    const headers = {
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };

    const response = await fetch(addHost(url), {
      method: 'GET',
      headers: headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      const errorData = errorText && JSON.parse(errorText);
      const error = (errorData && errorData.message) || response.statusText;
      throw new Error(error);
    }

    return response.blob();
  }
};

async function makeRequest(url, options) {
  const token = localStorage.getItem('access_token');

  const headers = {
    ...(options.method !== 'POST' || typeof options.body !== 'object' ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };

  const requestOptions = {
    ...options,
    headers
  };

  const response = await fetch(addHost(url), requestOptions);
  return handleResponse(response);
}

function handleResponse(response) {
  return response.text().then(text => {
    console.log(response.status);
    const data = text && JSON.parse(text);
    if (response.status === 401) {


      //return to login if it is 401 
      goToLogin();
      throw new Error(data.message || 'Unauthorized');
    }
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      throw new Error(error);
    }
    return data;
  });
}

function addHost(url) {
  if (process.env.NODE_ENV === 'development') {
    return url;
  }

  if (window.location.href.indexOf('df51rzg9dlhjd.cloudfront.net') !== -1) {
    //dev
    return 'https://df51rzg9dlhjd.cloudfront.net' + url;

  } else if (window.location.href.indexOf('d1gtzn7vbky6sa.cloudfront.net') !== -1) {
    //dev new
    return 'https://d1gtzn7vbky6sa.cloudfront.net' + url;

  } else if (window.location.href.indexOf('d38rqeus1y6mrh.cloudfront.net') !== -1) {
    //uat
    return 'https://d38rqeus1y6mrh.cloudfront.net' + url;
  } else {
    //prod
    return url;
  }
}

function goToLogin() {
  localStorage.removeItem('access_token');
  window.location.href = '/login';
}

export default fetchWrapper;